export default __webpack_public_path__ + "static/media/Barley.7913384f.jpg";